import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export const Cursor = () => {
  const [hovering, setHovering] = useState(false);
  const [hidden, setHidden] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.6 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.6 });

  useEffect(() => {
    if (window.matchMedia("(max-width: 768px)").matches) {
      setHidden(true);
      return;
    }
    const move = (e) => {
      x.set(e.clientX - 8);
      y.set(e.clientY - 8);
      const el = e.target;
      setHovering(!!el.closest("a, button, [data-cursor-hover]"));
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  if (hidden) return null;

  return (
    <motion.div
      data-testid="custom-cursor"
      className="fixed top-0 left-0 z-[9999] pointer-events-none mix-blend-difference"
      style={{ x: sx, y: sy }}
    >
      <motion.div
        className="rounded-full bg-[#e1ff00]"
        animate={{
          width: hovering ? 48 : 16,
          height: hovering ? 48 : 16,
          x: hovering ? -16 : 0,
          y: hovering ? -16 : 0,
        }}
        transition={{ type: "spring", stiffness: 400, damping: 28 }}
      />
    </motion.div>
  );
};
